import {
  GET_CUSTOMER_ADDRESS_REQUEST,
  LIST_CUSTOMER_ADDRESSES_REQUEST,
  ADD_CUSTOMER_ADDRESS_REQUEST,
  EDIT_CUSTOMER_ADDRESS_REQUEST,
  DELETE_CUSTOMER_ADDRESS_REQUEST,
  RESET_CUSTOMER_ADDRESS_QUERY
} from './constants';

export const listCustomerAddresses = (queryString) => ({
  type: LIST_CUSTOMER_ADDRESSES_REQUEST,
  queryString
});

export const getCustomerAddress = (customerAddressId) => ({
  type: GET_CUSTOMER_ADDRESS_REQUEST,
  customerAddressId
});

export const addCustomerAddress = (customerAddress, successFunction) => ({
  type: ADD_CUSTOMER_ADDRESS_REQUEST,
  customerAddress,
  successFunction
});

export const editCustomerAddress = (
  customerAddressId,
  customerAddress,
  successFunction
) => ({
  type: EDIT_CUSTOMER_ADDRESS_REQUEST,
  customerAddressId,
  customerAddress,
  successFunction
});

export const deleteCustomerAddress = (customerAddressId, successFunction) => ({
  type: DELETE_CUSTOMER_ADDRESS_REQUEST,
  customerAddressId,
  successFunction
});

export const resetCustomerAddressQuery = () => ({
  type: RESET_CUSTOMER_ADDRESS_QUERY
});
